import React from 'react'
import styled from '@emotion/styled'

import { Flex } from 'lese'
import Section from 'Components/Section'
import { colors } from 'Constants'

const CardOuter = styled(Flex)`
  border: 1px solid ${colors.borderColor};
  padding: 8px;
`

const CardContent = styled.span`
  font-size: 1.6em;
  color: ${() => colors.secondary};
  margin-top: 32px;
  font-weight: bold;
`

export default ({ header, title, children, ...props }) => (
  <CardOuter xAlign="space-between" separation="8px" {...props}>
    {header && title && <Section header={header} title={title} />}
    <CardContent>{children}</CardContent>
  </CardOuter>
)
